import React from 'react';
import { Block } from '../../../../components';

import { BackButton } from '../../../procedures/components';
import ContainerProcedure from '@/presentation/modules/procedures/components/ContainerProcedure';

import { TitleInstitutional, ParagraphText } from './styles';

import TabsInstitutional from './components/TabsInstitutional';
import Spinner from '@/presentation/components/Spinner';
import ErrorMessage from '@/presentation/components/Error';

interface Props {
  handlerBack: any;
  titles: any[];
  isLoading: boolean;
  hasError?: boolean;
}
const InstitutionalInformationModuleView: React.FC<Props> = ({
  handlerBack,
  titles,
  isLoading,
  hasError
}) => {
  const [activeTab, setActiveTab] = React.useState(0); // Estado para la pestaña activa

  return (
    <div data-testid="Institutual-View">
      {isLoading && <Spinner />}

      {!isLoading && (
        <ContainerProcedure>
          <Block
            data-testid="button-back"
            customized
            justifyContent="flex-start"
            margin="0px 0px 16px"
          >
            <BackButton onClick={handlerBack} />
          </Block>
          <TitleInstitutional>Información institucional</TitleInstitutional>
          <ParagraphText>
            Accede a los documentos relevantes para tu vida universitaria,
            incluyendo guías, reglamentos y manuales vigentes.
          </ParagraphText>
          {hasError ? (
            <ErrorMessage />
          ) : (
            <TabsInstitutional
              titles={titles}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
            />
          )}
        </ContainerProcedure>
      )}
    </div>
  );
};

export default InstitutionalInformationModuleView;
